import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import "../Forms/css/register.css";

const token = localStorage.getItem('authToken');

class EditDeals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      couponCode: '',
      description: '',

      startDate: '',
      endDate: '',
      storeName: '',  // Store ID for display
      categoryName: '',  // Category ID for display
      brandName: '',  // Brand ID for display
      image: '',
      imageFile: null,
      stores: [],  // List of stores with IDs
      productCategories: [],  // List of categories with IDs
      brands: [],  // List of brands with IDs
      submissionStatus: null,
      id: null,
    };
  }

  async componentDidMount() {
    // Get the deal ID from the URL
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      this.fetchData(id); // Fetch deal data by ID
    } else {
      console.error("No match or id found in props");
    }

    // Fetch stores, categories, and brands
    try {
      const [storesResponse, categoriesResponse, brandsResponse] = await Promise.all([
        axios.get("https://brand.aasmo.in/api/admin/brands", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get("https://brand.aasmo.in/api/admin/getall-category", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get("https://brand.aasmo.in/api/admin/brandsnew", {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      console.log("Stores:", storesResponse?.data?.brands);
      console.log("Categories:", categoriesResponse?.data?.categories);
      console.log("Brands:", brandsResponse?.data?.data);

      this.setState({
        stores: storesResponse?.data?.brands,
        productCategories: categoriesResponse?.data?.categories,
        brands: brandsResponse?.data?.data || [],
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response) {
        console.error("Response error:", error.response.data);
      }
    }
  }

  formatDate(date) {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().slice(0, 16); // Format date to 'YYYY-MM-DDTHH:MM'
  }

  fetchData = async (id) => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getbyid-deals/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const couponData = response?.data;
      console.log("Fetched coupon data:", couponData);

      if (couponData) {
        this.setState({
          title: couponData?.title || '',
          couponCode: couponData?.couponCode || '',
          description: couponData?.description || '',
          startDate: this.formatDate(couponData?.startDate) || '',
          endDate: this.formatDate(couponData?.endDate) || '',
          storeName: couponData?.store?.[0]?._id || '', // Use ID for the store dropdown
          categoryName: couponData?.category?.[0]?._id || '', // Use ID for the category dropdown
          brandName: couponData?.brands?.[0]?._id || '', // Use ID for the brand dropdown
          image: couponData?.image || '',
        });
      } else {
        console.error("No coupon data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,  // Update the corresponding state value (categoryName or brandName)
    });
  };


  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({ [`${name}File`]: files[0] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id, title, couponCode, description, startDate, endDate, storeName, categoryName, brandName, imageFile } = this.state;

    // Convert dates back to ISO format
    const formattedStartDate = new Date(startDate).toISOString();
    const formattedEndDate = new Date(endDate).toISOString();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("couponCode", couponCode);
    formData.append("description", description);

    formData.append("startDate", formattedStartDate);
    formData.append("endDate", formattedEndDate);
    formData.append("store", storeName);
    formData.append("category", categoryName);
    formData.append("brands", brandName);

    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.put(`https://brand.aasmo.in/api/admin/update-deals/${id}`, formData, config);
      if (response && response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push('/list-deals');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
        this.setState({ submissionStatus: 'error' });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { stores, productCategories, brands, submissionStatus, title, description, couponCode, dealPrice, originalPrice, startDate, endDate, storeName, categoryName, brandName, image, imageFile } = this.state;

    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Deals</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={title}
                      onChange={this.handleChange}
                      placeholder="Title"
                    />
                  </div>
                  <div className="form-group">
                    <label>Coupon Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="couponCode"
                      value={couponCode}
                      onChange={this.handleChange}
                      placeholder="Coupon Code"
                    />
                  </div>
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="startDate"
                      value={startDate}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Product Category</label>
                    <select
                      className="form-control"
                      name="categoryName"
                      value={categoryName}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Category</option>
                      {productCategories.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.categoryName}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div className="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="image"
                      onChange={this.handleFileChange}
                    />
                    {image && !imageFile && <img src={image} alt="Deal" style={{ width: '100px', height: '100px' }} />}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={description}
                      onChange={this.handleChange}
                      placeholder="Description"
                    />
                  </div>
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="endDate"
                      value={endDate}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Store Name</label>
                    <select
                      className="form-control"
                      name="storeName"
                      value={storeName}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Store</option>
                      {stores.map((store) => (
                        <option key={store._id} value={store._id}>
                          {store.name}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div className="form-group">
                    <label>Brand</label>
                    <select
                      className="form-control"
                      name="brandName"
                      value={this.state.brandName}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Brand</option>
                      {this.state.brands.map((brand) => (
                        <option key={brand._id} value={brand._id}>
                          {brand.name}
                        </option>
                      ))}
                    </select>
                  </div>
                

                
                </div>
             
                
              </div>
              <div className="form-group col-md-12">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                  {submissionStatus && (
                    <div className={`alert ${submissionStatus === 'success' ? 'alert-success' : 'alert-danger'}`}>
                      {submissionStatus === 'success' ? 'Deal updated successfully!' : 'Error updating deal.'}
                    </div>
                  )}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(EditDeals);
